import tokenManager from 'client/utils/tokenManager';
import { generateApiErrObj } from 'client/hooks/useClientErrorHandler';

export const GET = 'GET';
export const PATCH = 'PATCH';
export const POST = 'POST';
export const DELETE = 'DELETE';
export const PUT = 'PUT';

export async function PromiseAll(promises = []) {
    const { errorResp } = await tokenManager.getAccessToken();
    if (errorResp) {
        throw generateApiErrObj(errorResp);
    }
    return Promise.all(promises);
}

export async function normalizeResponse(resp) {
    const rawPayload = await resp.text();
    try {
        const payload = JSON.parse(rawPayload);
        return { httpStatus: resp.status, headers: resp.headers, payload };
    } catch (e) {
        // 後端偶爾會回傳非 JSON 格式的錯誤訊息，導致 JSON.parse 失敗，所以用 sentry 紀錄 rawPayload 以利後續除錯
        console.log('rawPayload', rawPayload);
        return { httpStatus: resp.status, headers: resp.headers, rawPayload };
    }
}

export function normalizeBlobResponse(resp) {
    return resp.blob().then(blob => ({ headers: resp.headers, blob }));
}

export const ERROR_MESSAGES = {
    ROLE_AUTHORITIES_FAILED: 'Role Authorities Failed',
    OTP_VALIDATION_FAILED: 'Validate OTP fail.',
    TOKEN_REQUIRED: 'token is required',
    // promotion-tool 的活動權限與角色權限驗證共用這個 message，靠 code 區分
    PROMOTION_PERMISSION_DENIED: 'Permission denied',
    // fever-api 的 not found 慣例：httpStatus 是 400，真正的 404 放在 message
    NOT_FOUND: '404'
};

export const ERROR_CODES = {
    PERMISSION_DENIED: 'RLA-AU0-F0',
    AUTHORIZATION_FAILED: 'LAI-AU0-F0',
    // 有角色但該角色沒有這個操作的權限（message 皆為 "Permission denied"）
    PROMOTION_PERMISSION_DENIED: 'PMIVLD-AU0-F0',
    ROLE_VALIDATION_FAILED: 'ROLE-V0-F0',
    PRIZE_SAFETY_GUARD_FAILED: 'PZSG-V0-F0',
    COUPON_FILE_NAME_CONFLICT: 'PZVNFS-C0-FD0',
    COUPON_FILE_VALIDATION_FAILED: 'PZVNF-V0-F0',
    COUPON_FILE_PROCESSING_CANNOT_DELETE: 'PZVNFS-D0-FD0',
    COUPON_FILE_NOT_FOUND: 'PZVNFS-D0-FNF1',
    PROMOTION_STATUS_BLOCK: 'PM-V0-F0',
    // sponsor 查無資料（非權限問題）。*-R1-FNF1 是各服務共用的 not found，只有 SP- 是主辦單位
    SPONSOR_NOT_EXIST: 'SP-R1-FNF1'
};
